import { createSvgIcon } from '@mui/material';

const IconWork = createSvgIcon(
  <path d="M4 21.7773C3.45 21.7773 2.97933 21.584 2.588 21.1972C2.196 20.8098 2 20.3443 2 19.8008V8.92969C2 8.38613 2.196 7.92098 2.588 7.53423C2.97933 7.14683 3.45 6.95312 4 6.95312H8V4.97656C8 4.43301 8.196 3.96753 8.588 3.58012C8.97933 3.19337 9.45 3 10 3H14C14.55 3 15.021 3.19337 15.413 3.58012C15.8043 3.96753 16 4.43301 16 4.97656V6.95312H20C20.55 6.95312 21.021 7.14683 21.413 7.53423C21.8043 7.92098 22 8.38613 22 8.92969V19.8008C22 20.3443 21.8043 20.8098 21.413 21.1972C21.021 21.584 20.55 21.7773 20 21.7773H4ZM4 19.8008H20V8.92969H4V19.8008ZM10 6.95312H14V4.97656H10V6.95312Z" />,
  'work',
);

export default IconWork;
